import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { useTranslation } from "@coworker/locales";

interface ConfirmFooterProps {
  disabled: boolean;
  onConfirm: () => void;
}

export function ConfirmFooter({ disabled, onConfirm }: ConfirmFooterProps) {
  const { t } = useTranslation();

  return (
    <FixaModalFooter>
      <FixaButton
        data-testid="move-users-to-team-confirm-button"
        disabled={disabled}
        type="primary"
        onClick={onConfirm}
      >
        {t("confirmString")}
      </FixaButton>
    </FixaModalFooter>
  );
}
